import classNames from "classnames";
import React, { memo, useCallback } from "react";

import { Image } from "../../../components/elements";
import { IBannerItem } from "../../../contexts/ConfigContext/types";
import { PAGE_PARAM } from "../../constants";
import "./BannerSingle.scss";

interface IBannerSingleProps {
	image: IBannerItem;
	handleCategoryClick: (categoryId: string) => void;
	handleItemClick: (
		brand_menu_item_id: number,
		mode?: PAGE_PARAM,
		cart_item_index?: string
	) => void;
	"data-testid"?: string;
	className?: string;
}

const BannerSingle: React.FC<IBannerSingleProps> = ({
	image,
	handleCategoryClick,
	handleItemClick,
	className,
	"data-testid": dataTestId,
}) => {
	const handleImageClick = useCallback(() => {
		if (!image.bannerClickData) {
			return;
		}

		const { type, data } = image.bannerClickData;

		switch (type) {
			case "category":
				handleCategoryClick(data);
				break;
			case "item":
				handleItemClick(Number(data))();
				break;
		}
	}, [image.bannerClickData, handleCategoryClick, handleItemClick]);

	return (
		<div className={classNames("BannerSingle", className)} data-testid={dataTestId}>
			<Image
				src={image.src}
				alt="Banner"
				className={classNames("BannerSingleImage", {
					Clickable: image.bannerClickData,
				})}
				onClick={image.bannerClickData ? handleImageClick : undefined}
				data-testid="banner-single-image"
			/>
		</div>
	);
};

export default memo(BannerSingle);
